module.exports = __webpack_public_path__ + "static/media/week8-ticket-uber-fullstack.bc5f5711.md";